// Without options
// Vue.use(yourPlugin)
// With options
// Vue.use(yourPlugin, {
//     feedback: true,
//     control: true
// })
import { arrayUnique, findModel, validatorFound } from './Utils/vnode';
import { ruleRunner, errorBagCreator } from './Core/RuleRunner';
// import { findRule } from './Utils';

const optionsDefault = {
  feedback: {
    valid: true,
    invalid: true,
  },
  control: {
    valid: true,
    invalid: true,
  },
};

// function arrayUnique(array) {
//   var a = array.concat();
//   for(var i=0; i<a.length; ++i) {
//       for(var j=i+1; j<a.length; ++j) {
//           if(a[i] === a[j])
//               a.splice(j--, 1);
//       }
//   }
//   return a;
// }




export default {
  install(Vue, opts) {
    const options = { ...optionsDefault, ...opts };
    var allValidators = [];
    Vue.directive('taurus-validator', {
      // runs once, so this just setups the $validator obj on each decorated component
      // and is automatically not valid until tested
      bind(el, binding, vnode) {
        // console.log('bind-el: ', el);
        // console.log('bind-binding: ', binding);
        //console.log('bind-vnode: ', vnode);
        // console.log('bind-$root:::::::::::::::::: ', vnode.context.$root.$validator)
        
        // check if a validator exists if not create one
        // (useful for multi checkboxs looped in a v-for for example)
        if (!validatorFound(vnode)) {
          const model = findModel(vnode);
          const validatorObj = {
            vmod: model.expression,
            value: model.value,
            compId: vnode.data.attrs.id,
            valid: false,
            errorBag: errorBagCreator(binding.value.split('|')),
            tagName: el.tagName,
            vnode,
            el,
            rulesRan: false,
            fieldlabel: el.attributes.fieldlabel.nodeValue,
          };
          // make sure the allvalidator directive global is uptodate and unique
          allValidators = arrayUnique(allValidators.concat(validatorObj));
          // push the unique values to the Vue global$ 
          allValidators.forEach(v => {
            if(!vnode.context.$root.$validator.includes(v)) {  
              // console.log('not in array::::: ', v)            
              vnode.context.$root.$validator.push(v);
            }            
          })
          // console.log("bind");
          // console.log(findRule(validatorObj.errorBag, "required_if"));
        }
        // console.log('allvalidators: ', allValidators)
        // console.log('validator: ', vnode.context.$root.$validator)
      },
      // Updates values in the $validator obj then sends the
      // validator object to the rule runner
      // rule runner will then need to kick off the element update process and apply bs4 validation classes
      update(el, binding, vnode) {
        // console.log('1-update-id: ', vnode.data.attrs.id)
        // console.log('1-update-$validator:: ', vnode.context.$root.$validator)
        // console.log('1-update-allValidators', allValidators)
        //const validator = vnode.context.$root.$validator; // get validation array
        const model = findModel(vnode); // find current v-model
        const validatorObj = vnode.context.$root.$validator.find((d) => d.compId === vnode.data.attrs.id); // filter array by v-model name
        // update the values
        validatorObj.value = model.value == null ? '' : model.value;
        validatorObj.oldValue = model.oldValue == null ? '' : model.oldValue;
        validatorObj.vnode = vnode;

        // debug -->
        // console.log('update-model: ', model);
        // console.log('update-value: ', validatorObj.value ? validatorObj.value : '')
        // console.log("update-validator: ", validatorObj);

        // if value has changed check it --> send validatorObj off for testing,
        if (validatorObj.value !== validatorObj.oldValue) {
          ruleRunner(validatorObj, options);
        }
      },
      unbind(el, binding, vnode) {
        //const validator = vnode.context.$root.$validator; // get validation array
        //const model = findModel(vnode); // find current v-model
        const validatorObj = vnode.context.$root.$validator.findIndex(v => v.el === el); // filter array by v-model name
        // component removed so remove validation object
        vnode.context.$root.$validator.splice(validatorObj, 1);
        // keep the directive global upto date.
        const validatorIndex = allValidators.findIndex(i => i.el === el);        
        allValidators.splice(validatorIndex, 1);
      },
    });
    Vue.mixin({
      beforeCreate() {
        this.$validator = []; // setup an array for for components
      },
      methods: {
        checkForm() {
          // console.log('checkform_root:: ', this.$root.$validator)
          // console.log('checkform:: ', this)
          this.$root.$validator.forEach((r) => {
            ruleRunner(r, options);
          });
          return !this.$root.$validator.some((e) => e.valid === false);
        },
        formErrors() {
          let err = [];
          this.$root.$validator.forEach((v) => {
            v.errorBag.forEach((e) => {
              if (!e.valid) {
                err.push(e.feedback);
              }
            });
          });
          return err;
        },
        resetFeedback() {
          this.$root.$validator.forEach((r) => {
            const feedback = document.getElementsByName(r.compId)[0];
            const control = document.getElementById(r.compId);
            feedback.innerText = '';
            if (feedback.classList.contains('d-block')) {
              feedback.classList.remove('d-block');
            }
            if (control instanceof HTMLInputElement) {
              if (control.classList.contains('is-valid')) {
                control.classList.remove('is-valid');
              }
              if (control.classList.contains('is-invalid')) {
                control.classList.remove('is-invalid');
              }
            }
          });
        },
      },
    });
  },
};
